import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../context/SiteSettingsContext';
import '../styles.css';

export default function MaintenancePage() {
  const { settings } = useSiteSettings();
  const message = settings.maintenance.message;

  return (
    <div className="maintenance-page">
      <div className="maintenance-page__grain" aria-hidden="true" />
      <div className="maintenance-page__inner">
        <p className="maintenance-page__id font-mono">{'// SYS_MAINTENANCE'}</p>
        <div className="maintenance-page__icon" aria-hidden="true">
          <i className="fas fa-broadcast-tower" />
        </div>
        <h1>
          Site <span className="highlight">Offline</span>
        </h1>
        <p className="maintenance-page__message">{message}</p>
        <div className="maintenance-page__actions">
          <a
            href="https://twitch.tv/zemaxi"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            <i className="fab fa-twitch" aria-hidden="true" /> Watch on Twitch
          </a>
          <Link to="/admin/login" className="btn btn-secondary maintenance-page__admin-link">
            Admin login
          </Link>
        </div>
        <p className="maintenance-page__status font-mono">SYS // MAINTENANCE_MODE</p>
      </div>
    </div>
  );
}
